"use client"

import type React from "react"

import { MsalProvider } from "@azure/msal-react"
import { msalInstance } from "@/lib/auth-config"
import { useEffect, useState } from "react"

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [isInitialized, setIsInitialized] = useState(false)

  useEffect(() => {
    msalInstance.initialize().then(() => {
      // Handle redirect promise
      msalInstance.handleRedirectPromise().then(() => {
        setIsInitialized(true)
      })
    })
  }, [])

  if (!isInitialized) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-muted-foreground">Indlæser...</div>
      </div>
    )
  }

  return <MsalProvider instance={msalInstance}>{children}</MsalProvider>
}
